import { useTranslation } from 'react-i18next';
import theme from '../../../utils/theme';
import Icon from '../Icon';
import Dropdown, { DropdownItem } from '../Dropdown/Dropdown';

import { ReactComponent as MusicIcon } from '../../../icons/album-list.svg';
import { ReactComponent as CheckIcon } from '../../../icons/check.svg';
import { ReactComponent as ArrowDownIcon } from '../../../icons/arrow-down.svg';

import './PartTypeSelect.scss';

const PartTypeSelect = ({ name, value, options, error, onChange }) => {
  const { t } = useTranslation();
  // Stored part names are English; only the label is translated
  const label = (part) => t(`parts.${part}`, { defaultValue: part });
  const handleSelect = (option) => {
    onChange({ currentTarget: { name, value: option } });
  };

  return (
    <div className="mg-form-group">
      <Dropdown
        className="PartTypeSelect"
        align="left"
        menuClassName="menu"
        trigger={
          <span className={theme.renderPartColor(value, 'trigger')}>
            <Icon icon={<MusicIcon />} className="part-icon" />
            <span className="label">{label(value)}</span>
            <Icon icon={<ArrowDownIcon />} className="caret" />
          </span>
        }
      >
        {options.map((option) => (
          <DropdownItem
            key={option}
            className={theme.renderPartColor(option, 'option')}
            onClick={() => handleSelect(option)}
          >
            <Icon icon={<MusicIcon />} className="part-icon" />
            <span className="label">{label(option)}</span>
            {option === value && <Icon icon={<CheckIcon />} className="check-icon" />}
          </DropdownItem>
        ))}
      </Dropdown>
      {error && <small className="mg-form-text mg-form-text--error">{error}</small>}
    </div>
  );
};

export default PartTypeSelect;
